export * as alarms from '@wix/auto_sdk_motion_alarms/meta';
export * as metroinspector from '@wix/auto_sdk_motion_metroinspector/meta';
export * as products from '@wix/auto_sdk_motion_products/meta';
